import { Card, Content, Text, Link } from "@react-spectrum/s2";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

/**
 * "Coming soon" placeholder card shown at the end of the modular templates list
 * (both inside the wizard and on the home page).
 */
export const ModularPlaceholderCard = () => (
  <Card
    textValue="Placeholder"
    size="L"
    variant="quiet"
    styles={style({ size: "full" })}
  >
    <Content
      styles={style({
        alignContent: "center",
        justifyItems: "center",
        color: "neutral-subdued",
        backgroundColor: "transparent-overlay-50",
        borderRadius: "default",
        aspectRatio: "3 / 4",
      })}
    >
      <Text slot="title" styles={style({ color: "inherit" })}>
        We&apos;re just getting started
      </Text>
      <Text slot="description" styles={style({ color: "inherit" })}>
        More experiences coming soon
      </Text>
      <Link
        href="https://adobe.enterprise.slack.com/docs/T025FJ55H/F0BMM363EBU"
        target="_blank"
        variant="secondary"
        isStandalone
        UNSAFE_className={style({
          font: "ui-xs",
          color: "neutral-subdued",
          marginTop: 8,
        })}
      >
        Learn more
      </Link>
    </Content>
  </Card>
);
